import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export function AuthProvider({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [user, setUser] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Chargement initial à partir du localStorage
  useEffect(() => {
    console.log("🔍 AuthContext - Vérification de l'authentification au chargement");
    const token = localStorage.getItem("token");
    const userData = localStorage.getItem("user");
    
    console.log("🔍 Token présent:", !!token);
    console.log("🔍 UserData présent:", !!userData);

    if (token && userData) {
      try {
        const parsedUser = JSON.parse(userData);
        console.log("✅ AuthContext - Utilisateur authentifié:", parsedUser.email);
        setIsAuthenticated(true);
        setUser(parsedUser);
      } catch (error) {
        console.error("Erreur lors du parsing du user depuis localStorage:", error);
        localStorage.removeItem("user"); // Nettoie les données corrompues
      }
    } else {
      console.log("❌ AuthContext - Pas d'authentification trouvée");
    }
    
    setIsLoading(false);
  }, []);

  const login = (userData) => {
    setIsAuthenticated(true);
    setUser(userData);
    localStorage.setItem("user", JSON.stringify(userData));
  };

  const logout = () => {
    setIsAuthenticated(false);
    setUser(null);
    localStorage.removeItem("token");
    localStorage.removeItem("tenant_id");
    localStorage.removeItem("user");
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, login, logout, isLoading }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
